module.exports = __webpack_public_path__ + "static/media/vinyl-default.8c581320.webp";